import { handleEmbeds } from './embed';
import { SeasonalEvents } from './events';
import { Christmas2019EventInfo } from './events/christmas2019';
import { element, fragment } from './html';
import hljs from 'highlight.js';
import { updateHeaderMessageCounter } from './messages/header';
import { initTimingsOverlay } from './perf';
import { trackTimeElements } from './relatime';
import { initXhrActions } from './xhra';

// make these globally available for JSX
Object.defineProperty(window, '$element', { value: element });
Object.defineProperty(window, '$fragment', { value: fragment });

initTimingsOverlay();

window.addEventListener('DOMContentLoaded', function() {
    initXhrActions();
    trackTimeElements();

    updateHeaderMessageCounter();

    const events = new SeasonalEvents;
    events.add(new Christmas2019EventInfo);
    events.dispatch();

    hljs.highlightAll();

    handleEmbeds(document.querySelectorAll('.js-msz-embed-media'));
});
